// mvp-returns Phase H17 — Failed Operation status pill (dot + dark text, no coloured borders)

import { StatusBadgeHelp } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import type { FailedOpStatus } from "../../apis/failed-ops";
import { DotPill } from "../delivery/atoms";
import type { Tone } from "../delivery/atoms";

const STATUS_TONE: Record<FailedOpStatus, Tone> = {
  PENDING                     : "grey",
  RETRYING                    : "blue",
  MANUAL_INTERVENTION_REQUIRED: "amber",
  RESOLVED                    : "green",
  GIVEN_UP                    : "grey",
};

interface Props {
  status: FailedOpStatus;
  /** Hover popover from `order.failed-op-status` (@dehub/help R5). */
  help?: boolean;
}

export function FailedOpsStatusBadge({ status, help }: Props) {
  const { t } = useTranslation("returns");
  const label = t(`failedOps.status.${status}`, { defaultValue: "-" });
  const pill = <DotPill tone={STATUS_TONE[status] ?? "grey"}>{label}</DotPill>;
  return help ? <StatusBadgeHelp helpNs="order.failed-op-status" code={status} name={label}>{pill}</StatusBadgeHelp> : pill;
}
